import React from 'react'
import { Segmented } from 'antd'
import { SunOutlined, MoonOutlined, DesktopOutlined } from '@ant-design/icons'
import { useThemeMode } from '@pushly/aqe'
import type { SelectedThemeMode } from '@pushly/aqe'
import './style/sidebar-theme-toggle.scss'

const themeOptions = [
    { value: 'light', icon: <SunOutlined aria-hidden="true" /> },
    { value: 'system', icon: <DesktopOutlined aria-hidden="true" /> },
    { value: 'dark', icon: <MoonOutlined aria-hidden="true" /> },
]

export const SidebarThemeToggle: React.FC = () => {
    const { selectedMode, setSelectedMode } = useThemeMode()

    return (
        <div className="sidebar-theme-toggle" onClick={(e) => e.stopPropagation()}>
            <span className="sidebar-theme-toggle__label">Theme</span>
            <Segmented
                size="small"
                value={selectedMode}
                options={themeOptions}
                onChange={(val) => setSelectedMode(val as SelectedThemeMode)}
            />
        </div>
    )
}
